
// SearchResults.jsx
import React from 'react';
import './SearchResults.css';

const emptyMessages = [
  'Te vagy az első! 🎉',
  'Te nyitod a sort! 🚀',
  'Eddig senki sem nevezte el – most megtetted!',
  'Gratulálunk, úttörő vagy! 🏁',
  'Még nincs előzmény – tiéd az első becenév!',
  'Frissen felfedezett terep. 🌱',
  'Ez az első bejegyzés ehhez a rendszámhoz.',
  'Nulláról indulunk – jó kezdés!',
  'Még üres a tabella, töltsük meg!',
  'Első fecske! 🐦'
];

function pickRandom(arr) {
  return arr[Math.floor(Math.random() * arr.length)];
}

const SearchResults = ({ results, plateStyle = '' }) => {
  const hasResults = Array.isArray(results) && results.length > 0;

  if (!hasResults) {
    return (
      <div className={`search-results empty ${plateStyle}`}>
        <h4>Még nincs hasonló rendszám a rendszerben! {pickRandom(emptyMessages)}</h4>
      </div>
    );
  }

  return (
    <div className={`search-results nicknames ${plateStyle}`}>
      <h4>Hasonló rendszámok becenevei</h4>
      <ul className="nickname-list">
        {results.map((item, index) => (
          <li key={`${index}`} className="nickname-item">
            <span className="nickname">{item.nickname}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
export default SearchResults;
